import { FormattedMessage } from 'components/Commons/Translation'

import ArrowLong from 'assets/svg/arrowBig.svg?react'
import IconLabel from 'components/Commons/Icon/IconLabel'

import { Container, BackContainer, BackIcon, Loading } from './styled.js'

import translations from './translations'

function Close({ onClick, className, loading, disabled }) {
  return (
    <Container onClick={!disabled ? onClick : undefined} className={className} data-testid="btn_close">
      {loading ? <Loading color="white" /> : <FormattedMessage {...translations.close} />}
    </Container>
  )
}

export function Back({ onClick, label, className, dataTestId }) {
  return (
    <BackContainer onClick={onClick} className={className} data-testid={dataTestId}>
      <IconLabel
        Icon={<BackIcon component={ArrowLong} />}
        label={label ? label : <FormattedMessage {...translations.back} />}
      />
    </BackContainer>
  )
}

export default Close
